import { LinkType } from '@app/components/Header/Menu';
import { RoutePaths } from '@app/utilities/RoutePathVars';

export const SEARCH_TEXT_PACKAGE_TAB = `
Browse sailings with bonus savings and special extras, or choose from our exclusive vacation packages with air,
hotel, tours and more - only available at Online Vacation Center!
`;
export const WHY_US_TEXT_1 = `No membership needed. You'll have access to discounted fares, special extras and more,
because of our long-standing, award-winning partnership with the cruise lines and tour companies.`;
export const WHY_US_TEXT_2 = `Whether you prefer to shop online, over the phone or have deals sent directly to your inbox,
you'll receive personalized support and service from a qualified travel professional who knows your unique needs and preferences.`;
export const WHY_US_TEXT_3 = `Online Vacation Center has been in business for over 50 years.
As one of the country's largest cruise retailers, we are able to negotiate deals you won't find elsewhere.`;
export const WHICH_ONE_TEXT = `Whether you're looking for a great deal on a standalone cruise or an all-inclusive Enrichment Journeys®
voyage with airfare, hotels, meals, tours and so much more, Online Vacation Center has a vacation option that will meet your individual needs.
Choose what suits you best, based on your desired destination, pace and inclusions.`;
export const SUBSCRIBE_TEXT = `Don't miss out on any of our amazing specials
and exclusive offers! Online Vacation Center will send them right to your inbox.`;
export const VIKING_CRUISE_TEXT = `Destination focused and culturally enriching. Discover what makes Viking the world’s
leading small ship cruise line and browse exciting river, ocean and expedition itineraries.`;
export const TRAVEL_CORPORATION_TEXT = `Choose from 42 unique land vacation and river cruise brands.
Whether you're looking for a premium tour like those on Trafalgar,
or the freedom to design your own day on a Costsaver tour, there's a perfect vacation for you.`;
export const LOGIN_TEXT = `Don't miss out on any of our amazing specials and exclusive offers!
Online Vacation Center will send them right to your inbox. All you have to do is sign up with us today.`;

export const loginDealList = [
	'Early access to the best deals',
	'Exclusive offers just for you',
	'Secret sales and specials',
	'Value Inclusive Packages',
];

export const vacationCenter = [
	{
		title: 'About Us',
		link: RoutePaths.aboutPage,
		type: LinkType.Internal,
	},
	{
		title: 'Privacy Policy',
		link: RoutePaths.privacyPolicy,
		type: LinkType.Internal,
	},
	{
		title: 'Terms of Use',
		link: RoutePaths.generalTerms,
		type: LinkType.Internal,
	},
];

export const travelResources = [
	{
		title: 'Personal Vacation Managers',
		link: RoutePaths.managers,
		type: LinkType.Internal,
	},
	{
		title: 'Travel Insurance',
		link: RoutePaths.travelInsurance,
		type: LinkType.Internal,
	},
	{
		title: 'Passport Requirements',
		link: RoutePaths.passportRequirements,
		type: LinkType.Internal,
	},
	{
		title: 'Shore Excursions',
		link: 'https://www.shoreexcursionsgroup.com/?ID=34&source=header',
		type: LinkType.External,
	},
	{
		title: 'Frequently Asked Questions',
		link: RoutePaths.faqs,
		type: LinkType.Internal,
	},
];

export const getInTouch = [
	{
		title: 'Investors',
		link: RoutePaths.investors,
		type: LinkType.Internal,
	},
	{
		title: 'Careers',
		link: RoutePaths.careers,
		type: LinkType.Internal,
	},
	{
		title: 'Contact',
		link: '/get_contact.cfm?fuseaction=contact',
	},
];
